var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReferral = function SvgReferral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.609,
    d: "M11.91 11.063a4.46 4.46 0 0 0 4.461-4.46 4.46 4.46 0 0 0-4.46-4.46 4.46 4.46 0 0 0-4.46 4.46 4.46 4.46 0 0 0 4.46 4.46ZM9.387 4.08a3.55 3.55 0 0 1 2.525-1.044c.954 0 1.85.372 2.524 1.044a3.54 3.54 0 0 1 1.044 2.524c0 .955-.372 1.85-1.044 2.525a3.54 3.54 0 0 1-2.524 1.043c-.955 0-1.85-.371-2.525-1.043a3.54 3.54 0 0 1-1.043-2.525c0-.954.371-1.85 1.043-2.524Zm2.822 15.605H7.897a2.98 2.98 0 0 1-2.974-2.974c0-.794.31-1.54.871-2.102a2.95 2.95 0 0 1 2.103-.871h8.028c1.053 0 2.037.565 2.57 1.474a.444.444 0 0 0 .609.161.444.444 0 0 0 .16-.61 3.89 3.89 0 0 0-3.339-1.915H7.897a3.84 3.84 0 0 0-2.733 1.133 3.83 3.83 0 0 0-1.133 2.733 3.87 3.87 0 0 0 3.866 3.866h4.311a.448.448 0 0 0 0-.895Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CC5D",
    stroke: "#00CC5D",
    strokeWidth: 0.514,
    d: "M19.539 18.766h-1.8v-1.8a.385.385 0 1 0-.772 0v1.8h-1.8a.385.385 0 1 0 0 .772h1.8v1.8a.385.385 0 1 0 .772 0v-1.8h1.8a.385.385 0 1 0 0-.772Z"
  })));
};
export default SvgReferral;